import BillingComponent from "../components/BillingComponent/BillingComponent.js";

const Billing = () => {
  return (
    <BillingComponent />
  );
};

export default Billing;